import { render, staticRenderFns } from "./ex-release.vue?vue&type=template&id=6a987361&scoped=true&"
import script from "./ex-release.vue?vue&type=script&lang=js&"
export * from "./ex-release.vue?vue&type=script&lang=js&"
import style0 from "./ex-release.vue?vue&type=style&index=0&id=6a987361&scoped=true&lang=scss&"
import style1 from "./ex-release.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a987361",
  null
  
)

export default component.exports